import { InputBase, styled } from '@mui/material';

const StyledInput = styled(InputBase)(({ theme }) => ({
  padding: 7,
  paddingLeft: 16,
  position: 'relative',
  right: 0,
  backgroundColor: '#F1F3F4',
  borderRadius: 8,
  '& input': {
    padding: 8,
    fontWeight: 600,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontSize: 14,
  },
}));

export default StyledInput;
